document.addEventListener('DOMContentLoaded', function() {
  const tabButtonShipping = document.querySelector('.sf-product__section-tabs .sf-tab-header:last-child');
  tabButtonShipping.classList.remove('sf-tab-header');
  tabButtonShipping.classList.add('tab-button-shipping');
  
  const tabButtonNote = document.querySelector('.sf-product__section-tabs .sf-tab-header:nth-child(2)');
  tabButtonNote.classList.remove('sf-tab-header');
  tabButtonNote.classList.add('tab-button-note');

  const tabButtonDisclaimer = document.querySelector('.sf-product__section-tabs .sf-tab-header:nth-child(3)');
  tabButtonDisclaimer.classList.remove('sf-tab-header');
  tabButtonDisclaimer.classList.add('tab-button-disclaimer');

  const tabButtonNoteMobile = document.querySelector('.sf-product__section .sf__accordion-item:nth-child(2) .sf__accordion-button');
  tabButtonNoteMobile.classList.remove('sf__accordion-button');
  tabButtonNoteMobile.classList.add('tab-button-note');

  const tabButtonShippingMobile = document.querySelector('.sf-product__section .sf__accordion-item:last-child .sf__accordion-button');
  tabButtonShippingMobile.classList.remove('sf__accordion-button');
  tabButtonShippingMobile.classList.add('tab-button-shipping');
});

document.addEventListener('DOMContentLoaded', function() {
    const tabButtonsNote = document.querySelectorAll('.tab-button-note');
    const tabButtonsShipping = document.querySelectorAll('.tab-button-shipping');
    const tabButtonsDisclaimer = document.querySelectorAll('.tab-button-disclaimer');
    const textContainer = document.getElementById('product-information');

    tabButtonsNote.forEach(tabButtonNote => {
        tabButtonNote.addEventListener('click', async () => {
            const templateModule = await import('./product-note2.js');
            const html = templateModule.default;
            textContainer.innerHTML = html;
            const textWrap = document.querySelector('.product-popup__wrap');
            const closeButton = document.querySelector('.close-btn-popup');
            
            textWrap.addEventListener('click', function(event) {
                const productPopup = document.querySelector('.product-popup');
                if (productPopup && !productPopup.contains(event.target)) {
                    textContainer.innerHTML = '';
                }
            });
        
            closeButton.addEventListener('click', function() {
                textContainer.innerHTML = '';
            });
        });
    });

    tabButtonsShipping.forEach(tabButtonShipping => {
        tabButtonShipping.addEventListener('click', async () => {
            const templateModule = await import('./product-shipping3.js?v=1.1');
            const html = templateModule.default;
            textContainer.innerHTML = html;
            const textWrap = document.querySelector('.product-popup__wrap');
            const closeButton = document.querySelector('.close-btn-popup');
            
            textWrap.addEventListener('click', function(event) {
                const productPopup = document.querySelector('.product-popup');
                if (productPopup && !productPopup.contains(event.target)) {
                    textContainer.innerHTML = '';
                }
            });
        
            closeButton.addEventListener('click', function() {
                textContainer.innerHTML = '';
            });
        });
    });
  
    tabButtonsDisclaimer.forEach(tabButtonDisclaimer => {
        tabButtonDisclaimer.addEventListener('click', async (e) => {
            e.preventDefault();
            const templateModule = await import('./product-disclaimer.js');
            const html = templateModule.default;
            textContainer.innerHTML = html;
            const textWrap = document.querySelector('.product-popup__wrap');
            const closeButton = document.querySelector('.close-btn-popup');
            
            textWrap.addEventListener('click', function(event) {
                const productPopup = document.querySelector('.product-popup');
                if (productPopup && !productPopup.contains(event.target)) {
                    textContainer.innerHTML = '';
                }
            });
        
            closeButton.addEventListener('click', function() {
                textContainer.innerHTML = '';
            });
        });
    });
  
});

// -------------------------------- Vehicle Fitment
// document.addEventListener('DOMContentLoaded', function() {
//   var vehicleWrap = document.querySelector('.vehicle__wrap');
//   var vehiclePopup = document.querySelector('.vehicle__popup');

//   vehicleWrap.addEventListener('click', function(event) {
//     if (vehiclePopup.style.maxHeight === '0px' || vehiclePopup.style.maxHeight === '') {
//       vehiclePopup.style.maxHeight = vehiclePopup.scrollHeight + 'px';
//       vehiclePopup.style.paddingTop = '10px';  // Установите нужное значение padding
//       vehiclePopup.style.paddingBottom = '10px'; // Установите нужное значение padding
//     } else {
//       vehiclePopup.style.maxHeight = '0';
//       vehiclePopup.style.paddingTop = '0';
//       vehiclePopup.style.paddingBottom = '0';
//     }
//     event.stopPropagation(); // предотвратить клик по документу
//   });

//   document.addEventListener('click', function() {
//     vehiclePopup.style.maxHeight = '0';
//     vehiclePopup.style.paddingTop = '0';
//     vehiclePopup.style.paddingBottom = '0';
//   });

// });